import { Link } from 'react-router-dom';
import { Shield, UserCheck, ClipboardCheck, MapPin, Phone } from 'lucide-react';
import { Button } from '../components/ui/button';
import SEO from '../components/SEO';

const About = () => {
  const staff = [
    {
      name: 'Dr. Boris Havkin, MD',
      role: 'Board-Certified Urologist',
      image: 'https://customer-assets.emergentagent.com/job_672d1315-e63e-45a4-b5f9-5a02f895fa2f/artifacts/cahm80lh_Dr.Boris%20Havkin%2C%20MD_b%26w.jpg',
      bio: 'Dr. Havkin has been delivering highest quality, highly personalized urological care and men\'s healthcare since 1998. In the first half of his career, he focused on minimally invasive oncological care, including laparoscopic and robotic surgery with high focus on technical innovation, female pelvic reconstruction surgery combined with highly personalized restorative men\'s health practice. After over 20 years in practice, Dr. Havkin has narrowed his focus to outpatient high end men\'s health practice, including screening, diagnoses and early stages of treatment of all male cancers, but particularly specializing and focusing on delivery of high-quality care in men\'s health, including hormonal management, nutritional management (including but not limited to TRT), management of lower urinary tract disease, including but not limited to BPH (prostate enlargement), OAB (overactive bladder), incontinence, lower urinary tract symptoms, recurrent infectious processes, difficult to treat prostatitis as well as aggressive care of sexual dysfunction, including erectile dysfunction, Peyronie\'s disease, ejaculatory dysfunction, testosterone deficiency, gynecomastia, orgasmic dysfunction, premature ejaculation, delayed ejaculation etc. Dr. Havkin practices diagnosis and management of recurrent stone disease. Practice also includes management of family planning with high-quality and painless vasectomy. Dr. Havkin\'s expertise comes after many years of education starting with Summa Cum Laude BS in Biology from City University of New York in Brooklyn College followed by MD in Downstate Health Sciences University Medical College in New York City and subsequent six years of Surgical Urological Residency training in Upstate Medical University in Syracuse, New York. He is Board certified by National Board of Physicians and Surgeons. He has practiced in Melbourne, FL since 2004. He served as a Urological surgeon specializing in Minimally invasive robotic and laparoscopic oncology and reconstruction, Female pelvic reconstruction, Urological prosthetics, complex stone disease management, HRT, Sexual dysfunction in MIMA Medical Group until 2016. He has begun operating highly regarded Havkin Urology since 06/2016. Dr. Havkin has been described as a doctor\'s doctor and has been honored to be trusted to provide high quality care to many of his respected colleagues in Brevard medical community.',
    },
    {
      name: 'Ronda Sheppard, AA (BS in progress)',
      role: 'Office Manager',
      image: 'https://customer-assets.emergentagent.com/job_672d1315-e63e-45a4-b5f9-5a02f895fa2f/artifacts/zg3ixqdi_Ronda%20Sheppard_b%26w.jpg',
      bio: 'Ronda oversees the daily operations of our practice, ensuring that every patient receives exceptional service from the moment they walk through the doors. She served in the United States Air Force and during that time she attended CCAF and completed her AA. Ronda moved to Melbourne in 1998 and has worked in the medical field since. She has over 25+ years of experience in healthcare and has worked in numerous specialties with her primary focus in Urology. Ronda has managed Havkin Urology for the last 10 years. Her dedication to efficiency and patient satisfaction keeps our office running smoothly.',
    },
    {
      name: 'Natalie Havkin, MS CCC/SLP',
      role: 'Practice Consultant',
      phone: null,
      image: 'https://customer-assets.emergentagent.com/job_672d1315-e63e-45a4-b5f9-5a02f895fa2f/artifacts/79fsziby_Natalie%20Havkin%2C%20MS%20CCC_SLP_b%26w.jpg',
      bio: 'Graduate of Columbia University in New York City having moved to Upstate New York for extensive 6 year post graduate medical training in the department of ENT, SUNY Upstate Medical University. Relocated to sunny Florida in 2004. Has 22 years experience in the medical field specializing in nutrition, hormonal imbalances, and healthy lifestyle. Has been a part of Team Havkin for 10 years.',
    },
    {
      name: 'Christina Head, RMA, CNS',
      role: 'Head Clinical Nurse',
      image: 'https://customer-assets.emergentagent.com/job_672d1315-e63e-45a4-b5f9-5a02f895fa2f/artifacts/ziqzb1u4_Christina%20Head_b%26w.jpg',
      bio: 'I hold a two-year Medical Associate\'s degree from Keiser University and am a local graduate of Eau Gallie High School. I have over 15 years of experience working alongside Dr. Havkin, starting at age 21. As the clinical lead, I provide full clinical support, from assisting with in-office procedures and patient care to managing charting and labs. I\'m cross-trained in both clinical and clerical roles and help keep patient flow running smoothly throughout the office. Outside of work, I enjoy concerts when I can. Taylor Swift is usually playing in the background... long story short, I\'m a big fan. I also stay involved in the All-Star cheer world and, after years around the sport, hope to one day be on the judge\'s side of the table.',
    },
    {
      name: 'Shannon Holak',
      role: 'Front Desk/Patient Coordinator',
      image: 'https://customer-assets.emergentagent.com/job_672d1315-e63e-45a4-b5f9-5a02f895fa2f/artifacts/bue7ruwh_Shannon%20Holak_b%26w.jpg',
      bio: 'Formerly with MIMA/Healthfirst. 15+ years experience in the medical field ranging from medical records to medical secretary. Has been a part of Havkin Urology since 2019.',
    },
    {
      name: 'Dawn Matrigali, RMA, CNS (RN/BSN in progress)',
      role: 'Urodynamics Specialist',
      image: 'https://customer-assets.emergentagent.com/job_672d1315-e63e-45a4-b5f9-5a02f895fa2f/artifacts/s5gbs1w4_Dawn%20Matrigali_b%26w.jpg',
      bio: 'Educated at Indian River State College in nursing and currently pursuing a BSN bridge to ARNP at Eastern Florida State College, she brings a well-rounded clinical background with 3 years in cardiology, 7 years in pediatrics, and 20 years in urology. Has been a valued member of Team Havkin since 2018, continuing her work alongside Dr. Havkin from their time at MIMA. Enjoys spending time outdoors and has a deep love for animals.',
    },
  ];

  const values = [
    {
      icon: Shield,
      title: 'Discreet & Professional',
      description: 'Your privacy matters. We provide a comfortable, confidential environment where you can discuss sensitive health concerns openly.',
    },
    {
      icon: UserCheck,
      title: 'Thorough Evaluation',
      description: 'We take time to understand your symptoms, history, and goals. A proper diagnosis is the foundation of effective treatment.',
    },
    {
      icon: ClipboardCheck,
      title: 'Clear Options & Next Steps',
      description: 'After evaluation, we explain your options in plain language so you can make informed decisions about your care.',
    },
  ];

  return (
    <div className="pb-20 md:pb-0" data-testid="about-page">
      <SEO
        title="About Our Practice"
        description="Learn about Havkin Urology in Melbourne, FL. Dr. Boris Havkin is a board-certified urologist providing confidential, professional men's health care in Brevard County."
        keywords="about Havkin Urology, Dr. Boris Havkin, urologist Melbourne Florida, board-certified urologist, Brevard County urology"
        canonical="/about"
      />
      {/* Hero */}
      <section className="py-16 md:py-20 bg-slate-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div>
              <h1 className="font-heading text-4xl md:text-5xl font-bold text-primary mb-6">
                About Havkin Urology
              </h1>
              <p className="text-lg text-slate-600 mb-6">
                After 12 years of taking care of patients as a partner at MIMA, Dr. Havkin is ready to welcome you to his own private practice. The friendly team of well-trained and dedicated professionals remains the same.
              </p>
              <p className="text-slate-600">
                Dr. Havkin and the team come to work with only one stated goal: Delivery of the Best, State of the Art, personalized and compassionate care from the 1st moment our relationship with the patient begins. We want our patients to feel safe, heard, comfortable, taken care of and at home when they come to our practice.
              </p>
            </div>
            <div className="relative">
              <img
                src="https://customer-assets.emergentagent.com/job_672d1315-e63e-45a4-b5f9-5a02f895fa2f/artifacts/cahm80lh_Dr.Boris%20Havkin%2C%20MD_b%26w.jpg"
                alt="Dr. Boris Havkin - Urologist"
                className="rounded-xl shadow-lg w-full h-auto object-cover max-w-md mx-auto"
              />
              <p className="text-center mt-4 font-heading text-lg font-semibold text-primary">Dr. Boris Havkin, MD</p>
              <p className="text-center text-slate-600">Board-Certified Urologist</p>
            </div>
          </div>
        </div>
      </section>

      {/* Our Approach */}
      <section className="py-16 md:py-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="font-heading text-3xl md:text-4xl font-bold text-primary mb-4">
              Our Philosophy
            </h2>
            <p className="text-lg text-slate-600 max-w-3xl mx-auto">
              Dr. Havkin provides total Urological care and explores patient's entire history to diagnose and correct any and all urological issues. Many a times patients will come to accept their maladies as the norm or as expected without realizing that improvement and normalization are feasible and often easily attainable when receiving proper diagnosis and care. We strive to identify your problem/problems and won't rest until we can make you better.
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8">
            {values.map((value, index) => (
              <div 
                key={index}
                className="text-center p-8"
                data-testid={`value-${index}`}
              >
                <div className="inline-flex items-center justify-center w-16 h-16 bg-brand/10 rounded-full mb-6">
                  <value.icon className="h-8 w-8 text-brand" />
                </div>
                <h3 className="font-heading text-xl font-semibold text-primary mb-3">
                  {value.title}
                </h3>
                <p className="text-slate-600">
                  {value.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Meet Our Team */}
      <section className="py-16 md:py-24 bg-slate-50" data-testid="about-staff-section">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="font-heading text-3xl md:text-4xl font-bold text-primary mb-4">
              Meet Our Team
            </h2>
            <p className="text-lg text-slate-600 max-w-2xl mx-auto">
              Dedicated professionals committed to your care and comfort.
            </p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {staff.map((member, index) => (
              <div 
                key={index}
                className="bg-gray-200 rounded-xl p-6 text-center"
                data-testid={`about-staff-card-${index}`}
              >
                <div className="w-32 h-32 mx-auto mb-4 rounded-full overflow-hidden bg-gray-300">
                  {member.image ? (
                    <img 
                      src={member.image} 
                      alt={member.name}
                      className="w-full h-full object-cover"
                    />
                  ) : (
                    <div className="w-full h-full flex items-center justify-center text-gray-400 text-4xl font-heading">
                      {member.name.charAt(0)}
                    </div>
                  )}
                </div>
                <h3 className="font-heading text-xl font-semibold text-primary mb-1">
                  {member.name}
                </h3>
                <p className="text-black font-medium text-sm mb-3">{member.role}</p>
                {member.phone && (
                  <a href={`tel:${member.phone.replace(/[^0-9]/g, '')}`} className="text-slate-600 text-sm block mb-3 hover:text-black">
                    {member.phone}
                  </a>
                )}
                <p className="text-slate-600 text-sm leading-relaxed">
                  {member.bio}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Location */}
      <section className="py-16 md:py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="font-heading text-3xl md:text-4xl font-bold text-primary mb-6">
                Serving Brevard County
              </h2>
              <p className="text-lg text-slate-600 mb-6">
                Our office is conveniently located in Melbourne, Florida, serving patients throughout Brevard County and the Space Coast region.
              </p>
              <div className="space-y-4">
                <div className="flex items-start">
                  <MapPin className="h-6 w-6 text-brand flex-shrink-0 mr-3 mt-0.5" />
                  <div>
                    <p className="font-medium text-primary">Office Location</p>
                    <p className="text-slate-600">
                      3021 W Eau Gallie Blvd, Suite 103<br />
                      Melbourne, FL 32934
                    </p>
                  </div>
                </div>
                <div className="flex items-start">
                  <Phone className="h-6 w-6 text-brand flex-shrink-0 mr-3 mt-0.5" />
                  <div>
                    <p className="font-medium text-primary">Phone</p>
                    <a href="tel:+13215004545" className="text-brand hover:text-brand-hover">
                      (321) 500-4545
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div className="map-container h-80 lg:h-96 rounded-xl overflow-hidden shadow-lg">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3517.0647684661815!2d-80.67252492392!3d28.106866211548!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88de11e8d0d0e8d5%3A0x1234567890abcdef!2s3021%20W%20Eau%20Gallie%20Blvd%20%23103%2C%20Melbourne%2C%20FL%2032934!5e0!3m2!1sen!2sus!4v1234567890"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Havkin Urology Location"
              ></iframe>
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-16 md:py-20 bg-primary">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-white mb-4">
            Ready to Schedule?
          </h2>
          <p className="text-lg text-slate-300 mb-8">
            Contact us today to schedule your confidential consultation.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button
              asChild
              size="lg"
              className="bg-brand hover:bg-brand-hover text-white rounded-full px-8"
              data-testid="about-cta-appointment"
            >
              <Link to="/contact">Request Appointment</Link>
            </Button>
            <a
              href="tel:+13215004545"
              className="inline-flex items-center justify-center px-8 py-3 bg-transparent border-2 border-white text-white rounded-full font-medium hover:bg-white/10 transition-colors"
              data-testid="about-cta-call"
            >
              <Phone className="h-5 w-5 mr-2" />
              (321) 500-4545
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
